// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44497":"17852b85","67225":"58b6864b","88283":"17852b85"}[chunkId] + ".chunk.css";
};